import { apiGet } from './api';

export interface CapacityData {
  elastic_ips: {
    limit: number;
    used: number;
    available: number;
    device_ips: number;
    infrastructure_ips: number;
  };
}

export async function getCapacity(): Promise<CapacityData> {
  return apiGet<CapacityData>('/capacity');
}
